<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    class="inline-block"
    :class="{
      [sizeClass]: !noStyle,
      [customClass]: customClass,
    }"
  />
</template>

<script setup lang="ts">
import useIcon from '../../../composables/useIcon'

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '5',
  },
  noStyle: {
    type: Boolean,
    default: false,
  },
})

const { getIconComponent } = useIcon()
const sizeClass = computed(() => `w-${props.size} h-${props.size}`)
const iconComponent = await getIconComponent(props.icon)

// tailwind classes:
// w-4 h-4
// w-5 h-5
// w-6 h-6
// w-7 h-7
// w-8 h-8
</script>
